<template>
    <div class="tab-pane" id="online-admission-detail" :class="{'active' : user_type=='3'}" aria-labelledby="online-admission-detail">
        <div class="card">
            <label class="card-header text-center"><strong>The Students Availing Government Scholarships to Private School</strong></label>
            <table class="table table-bordered table-striped" id="OrgDetails">
                <thead>
                    <tr>
                        <th></th>
                        <th colspan="4" class="text-center">Student Information</th>
                        <th colspan="5" class="text-center">Student Placement</th>
                    </tr>
                    <tr>
                        <th>S.No</th>
                        <th>Name of Student</th>
                        <th>Index Number</th>
                        <th>Dzongkhag</th>
                        <th>School</th>
                        <th>Dzongkhag</th>
                        <th>School</th>
                        <th>Class</th>
                        <th>Stream</th>
                        <th>Applied At</th>
                        <th v-if="show_remarks_column == 1">Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in admission_details" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.std_indexno}}</td>
                        <td>{{item.dzongkhag}}</td>
                        <td>{{item.organization}}</td>
                        <td>{{item.placement_dzongkhag}}</td>
                        <td>{{item.placement_organization}}</td>
                        <td>{{item.class}}</td>
                        <td>{{item.stream}}</td>
                        <td>{{new Date(item.created_at)}}</td>
                        <td v-if="show_remarks_column == 1">
                            <span v-if="item.remarks =='admitted'">
                                Admitted
                            </span>
                            <span v-else>
                                Not Admitted
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
             <div class="text-right mb-2 mr-2">
                <button v-if="show_remarks_column!=1" type="button" class="btn btn-primary" @click="admitStudents"><i class="fa fa-user-check"></i>  Admit</button> 
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            user_type:'',
            admission_details:[],
            show_remarks_column:0
        }
    },
    methods:{
        getAllApplication(){
            axios.get('admissions/getAllApplication').then(res =>{
                let data = res.data
                    data.forEach(item => {
                        this.show_remarks_column = item.show_remarks_column;
                    })
                this.admission_details = data;
               
            }).catch(error => console.log(error));
        },
        admitStudents(){

            let filteredData = this.admission_details.filter(item => item.remarks == 'admitted');

            Swal.fire({
                 title: 'Do you want to admit students?',
                 icon: 'warning',
                 showCancelButton: true,
                 confirmButtonColor: '#3085d6',
                 cancelButtonColor: '#d33',
                 confirmButtonText: 'Yes',
                 }).then((result) => {
                        if(result.isConfirmed) {
                            axios.post('admissions/updateAdmissionRemarks',{data:filteredData})
                            .then(() => {
                                Toast.fire({
                                    icon: 'success',
                                    title: 'Admitted 2 students successfully out of '+this.admission_details.length
                                })
                                this.$router.go(this.$router.currentRoute)
                            }) .catch(error=>console.log(error))
                        }
                    })

        }
    },
    mounted(){
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.user_type=data['role'];;
        })
        this.getAllApplication();
    }
    
}
</script>